import Input from './Input.vue'
export default Input



// WEBPACK FOOTER //
// ./components/Input/index.js